import React from 'react'

function Cricketpage() {
  return (
    <div>Cricketpage</div>
  )
}

export default Cricketpage